
import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import Axios from "../../config/axiosConfig/axios";
import { Api} from "../../config/apiList/api";
import {Row, Col, Table, Input, Button, notification, Pagination, Checkbox} from 'antd';
import { Link } from 'react-router-dom';
import './../settings/settings.css'
import { SpinnerDotted } from 'spinners-react';
import CopyOutlined from '@ant-design/icons'
// import Mod from "../userDetails/EditUserDetail";
import {render} from "react-dom";
// import 'bootstrap/dist/css/bootstrap.min.css'
import SelectionTable from "./selectionTable";

function Settings() {
    const [settingList, setSettingList] = useState("");
    const [step, setStep] = useState(0);
    const [serach, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [changableBtn, setChangableBtn] = useState(false);




    // const [copy, setCopy] = useState(0);
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
        },
        // getCheckboxProps: record => ({
        //     disabled: record.name === 'Disabled User', // Column configuration not to be checked
        //     name: record.name,
        // }),
    };


    const GreenNotification = (text) => {
        notification.open({
            message: "موفقیت",
            description: text,
            style: {
                background: "#43a047",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    useEffect( () => {
        Axios.get(`${Api}getAllSettings`
        )
            .then((data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    setStep(1)
                    setSettingList(data.data.data);
                }

            })
            .catch((error) => {
            });
    }, []);

    function setNewSettingList(data){
        setSettingList(data);
    }

    const searching = () => {
        if (serach.length !== 0) {
            Axios.get(`${Api}getAllSettings?search=${serach}`)
                .then((data) => {
                    if (data.statusCode === 200 || data.statusCode === 201) {

                        setStep(1);
                        setSettingList(data.data.data);
                    }

                })
                .catch((error) => {
                    RedNotification("مشکلی در اتصال به سرور به وجود آمده است‌ !")
                });
        } else {
            RedNotification("برای جستجو ابتدا باید نام کاربر را وارد نمایید")
        }
    }
    //
    // const roleManager = (role) => {
    //     switch (role) {
    //         case 1: return "مدیر"
    //         case 2: return "اپراتور"
    //         case 3: return "مشتری"
    //     }
    // }

    const columns = [
        {
            title: 'کلید',
            dataIndex: 'key',

        },


        {
            title: 'روز',
            // dataIndex: 'validity',
            render:  (e) => {

            },

        },

        {
            title: 'قیمت',
            // dataIndex: 'validity',
            render: (e) => {return <input/>}

        },

        // {
        //     title: 'کد فعالسازی',
        //     render: (e) => {return <div>
        //         <p style={{fontFamily: "arial"}}>{ "...."+ e.licence.substring(0,20)}</p>
        //         <Button onClick={async event => {
        //
        //
        //             await navigator.clipboard.writeText(e.licence);
        //             notification.open({
        //                 message: "انجام شد",
        //                 description: "کد فعالسازی کپی شد!",
        //                 style: {
        //                     background: "#43a047",
        //                     color: "white",
        //                     fontFamily: "IRANSansMobileFaNum",
        //                     borderRadius: "5px",
        //                 }
        //             })
        //
        //         }} style={{  backgroundColor: "white",
        //             color: "#3174ff",
        //             border: "2px solid #ffffff" /* Green */}}>کپی</Button>
        //     </div>}
        //     // dataIndex: 'licence',
        //
        // },
        // {
        //     title: 'عمليات',
        //     render: (e) => {
        //         return  <></>
        //
        //     }
        //
        // },
    ];


    switch (step) {
        case 0:
            return <Row style={{ width: '100', justifyContent: 'center' }}>
                <SpinnerDotted size={89} thickness={180} speed={92} color="rgba(0, 0, 0, 0.85)" style={{ marginTop: '100px' }} />
            </Row>

        case 1:
            return (
                settingList
                    ? <>
                        <Row style={{ marginBottom: '50px' }}>
                            <h1 style={{justifyContent: "center", fontSize: 20}}>لطفا برای ویرایش یک سطر را انتخاب کنید!</h1>
                        {/*    <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} >*/}
                        {/*        <Input*/}
                        {/*            onChange={(e) => { setSearch(e.target.value) }}*/}
                        {/*            id="userSerachInput"*/}
                        {/*            placeholder='برای جستجو نام مشاور یا کد املاک را وارد نمایید...'*/}
                        {/*        />*/}
                        {/*    </Col>*/}
                        {/*    <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} >*/}
                        {/*        <Button onClick={searching} id='userSearchButton'>جستجوی تنظیمات</Button>*/}
                        {/*    </Col>*/}
                        </Row>

                       <SelectionTable columns={columns} settingList={settingList} setSettingList={setNewSettingList}/>

                        {/*<Row style={{width:'100%',justifyContent:'right'}}>*/}
                        {/*    <Button type="primary">ویرایش</Button>*/}
                        {/*</Row>*/}

                        {/*    <Pagination*/}
                        {/*        style={{direction:'ltr',marginTop:"20px"}}*/}
                        {/*        current={pageNumber}*/}
                        {/*        total={totalPage}*/}
                        {/*        pageSize={10}*/}
                        {/*        onChange={*/}
                        {/*            (e)=>{*/}
                        {/*                setPageNumber(e)*/}
                        {/*            }*/}
                        {/*        } />*/}

                    </>
                    :
                    <>
                        <p className='orderColumeText' >تنظیماتی در حال حاضر براي نمايش وجود ندارد</p>
                    </>
            )



    }
}
export default Settings;

